// import {CreateApplicationDetailsWConstants} from "../../create-application/modules/w/create-application-details-w/create-application-details-w.constants";
// TODO: add this back when we re-add Wayleaves application
export class CompareDatesUtil {
    static verifyProposedDates(form, startDateFormControlName, endDateFormControlName, sourceFormControl, appController) {
        const startDate = Date.parse(form.get(startDateFormControlName).value);
        const endDate = Date.parse(form.get(endDateFormControlName).value);
        if (startDate && endDate && (startDate > endDate)) {
            form.get(sourceFormControl).reset();
            // appController.showMessage(CreateApplicationDetailsWConstants.DATE_VALIDATION_ERROR, AlertType.Warning);
        }
    }
}
